module.exports = __webpack_public_path__ + "static/img/yu_right.156f507.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mainpage/yu_right.png
// module id = 9XAt
// module chunks = 3